import { DateTime } from 'luxon';

import { ServerChangeApi, ServerChangesApi } from '../../api/models/server-change-api';

export class ServerChange {
    public host: string;
    public date: DateTime;

    public static mapperFromApi(source: ServerChangeApi): ServerChange {
        const target = new ServerChange();

        target.host = source.host;
        target.date = DateTime.fromISO(source.date, { zone: 'utc' });

        return target;
    }
}

export class ServerChanges {
    public newServers: ServerChange[];
    public disappearedServers: ServerChange[];

    public static mapperFromApi(source: ServerChangesApi): ServerChanges {
        const target = new ServerChanges();

        target.newServers = (source.newServers ?? []).map(ServerChange.mapperFromApi);
        target.disappearedServers = (source.disappearedServers ?? []).map(ServerChange.mapperFromApi);

        return target;
    }
}
